import { memo } from 'react';
import { Typography } from '@mui/material';
import { cx } from '@emotion/css';

import { Heading, ProgressBar } from '_ui';
import { Chip } from '_ds';

import { getEnv } from '../global/config/env';
import { useI18n } from '../global/hooks/i18n';
import { useLocale } from '../global/hooks/locale';

import cn from './card.module.scss';

import Button from './Button';

import WcsHeadTag from '../assets/universes/wcs/headtag.svg';
import SpicedHeadTag from '../assets/universes/spiced/headtag.png';
import NfHeadTag from '../assets/universes/nf/headtag.png';

type CardProps = {
    ctaLabel: string;
    goToTraining: () => void | Promise<void>;
    isAvailable: boolean;
    loading: boolean;
    name: string;
    trainingType: string;
    color: string;
    track: string;
    headTag?: React.ReactNode;
    estimatedTime?: number;
    startsOn?: Date;
    progression?: number;
    droppedOutAt?: Date;
}

export const HeadTag = () => {

    const env = getEnv();
    const { universe } = env;

    if (universe === 'nf') return (<img src={NfHeadTag} alt="NF" />);
    if (universe === 'spiced') return <img src={SpicedHeadTag} alt="Spiced" />;

    return <WcsHeadTag />;
};

const Card = ({ ctaLabel, goToTraining, isAvailable, loading, name, trainingType, color, track, startsOn, progression, droppedOutAt }: CardProps) => {

    const t = useI18n('card');
    const locale = useLocale();

    return <article className={cx(cn.card, `training--${color}`)}>
        <div className={cn.content}
            onClick={goToTraining}>
            <div className={cn.headTag}>
                <HeadTag />
            </div>
            <div className={cn.track}>
                <Typography className={cn.track}>{track}</Typography>
            </div>
            <div className={cn.typenTime}>
                <Typography className={cn.type}>{t(`trainingTypes.${trainingType}`)}</Typography>
                {startsOn && <Chip label={t('startsOn', { date: new Date(startsOn).toLocaleDateString(locale) })} severity="warning" />}
                {droppedOutAt && <Chip label={t('droppedOutAt', { date: new Date(droppedOutAt).toLocaleDateString(locale) })} severity="neutral" />}
            </div>
            <div className={cn.training}>
                <Heading heading="h4" className={cx(cn.name, startsOn && cn.clampThree)}>{name}</Heading>
                {Number.isInteger(progression) && <ProgressBar progress={progression} className={cn.progress} />}
            </div>
            <div className={cn.cta}>
                <Button disabled={!isAvailable}
                    onClick={goToTraining}
                    label=""
                    className={cn.cardButton}
                    loading={loading}
                    aria-label={t(`startTraining.${ctaLabel}`)}
                />
            </div>
        </div>
    </article >;
};

export default memo(Card);
